import {useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {Button} from "../account/misc/Button";
import PosApi from "../../api/PosApi";
import {useRecoilValue} from "recoil";
import {memberState} from "../../state/atoms";
import {isTestEnv} from "../../util/constants";
import {Spinner} from "../account/misc/Spinner";
import CheckCircle from "../icons/CheckCircle";
import './Square.scss';
import squareTutorial from '../../img/square-tutorial.webp';
import {generateToken} from "../../util/utils";
import {error} from "../../service/MessageService";

export default function Square() {
  const [searchParams] = useSearchParams();
  const member = useRecoilValue(memberState);
  const [linked, setLinked] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const responseType = searchParams.get("response_type");
    const state = searchParams.get("state");
    const code = searchParams.get("code");

    if (!member || !member.id || !responseType || !code) return;

    if (window.localStorage.getItem('squareState') !== state) {
      setLoading(true);
      error("An error occurred. Please refresh this page and retry linking your Square account.");
    } else {
      setLoading(true);
      PosApi.authSquare({code, memberId: member.internalId}).then(() => {
        setLoading(false);
        setLinked(true);
        const url = window.location.href.split('?')[0];
        window.history.pushState({path: url}, "", url);
      });
    }
  }, [searchParams, member]);

  function connect() {
    const baseUrl = isTestEnv ? 'https://connect.squareupsandbox.com' : 'https://connect.squareup.com';
    const clientId = isTestEnv ? 'sandbox-sq0idb-iMRQBK9PoqMnCLFDUxG52A' : 'sq0idp-ZR73v4F9a_ZQMtaz-ahEAA';
    const scope = 'ITEMS_READ,MERCHANT_PROFILE_READ,INVENTORY_READ';
    const state = generateToken();
    window.localStorage.setItem('squareState', state);

    window.location.href = `${baseUrl}/oauth2/authorize?client_id=${clientId}&scope=${scope}&session=false&state=${state}`;
  }

  return <>
    {loading && <div className={'spinner'}><Spinner/></div>}
    {!linked && !loading && <Button onClick={connect}>Login into Square</Button>}
    {linked && <div className={'square-linked'}>
      <CheckCircle/>
      <h2>You're all set!</h2>
      <p>You can access your Square data in any design.</p>
      <div style={{backgroundImage: `url(${squareTutorial})`, backgroundRepeat: 'no-repeat', backgroundSize: 'contain', width: '576px', height: '360px', maxWidth: '100%'}}></div>
    </div>}
  </>
}
